import { useTheme } from "../../../../context/ThemeProvider";
import SharedApprovalCard from "@photon/chat-react/approval-card";

/**
 * ApprovalCard - CONTROLLED component for agent actions requiring user confirmation.
 * 
 * This is a display-only component. All state is managed by MainContent.
 * The card renders based on cardData.status prop.
 * 
 * @param {Object} cardData - Approval card data including status (pending|processing|approved)
 * @param {Function} onApprove - Callback when user clicks confirm (receives approval_id, confirmationText)
 * @param {Function} onCancel - Callback when user clicks cancel (receives approval_id)
 * @param {Function} onExpire - Callback when timer reaches zero (receives approval_id)
 */
const ApprovalCard = ({ cardData, onApprove, onCancel, onExpire }) => {
  const { theme } = useTheme();
  return (
    <SharedApprovalCard
      cardData={cardData}
      onApprove={onApprove}
      onCancel={onCancel}
      onExpire={onExpire}
      theme={theme}
    />
  );
};

export default ApprovalCard;
